import { Box, Container, Typography } from "@material-ui/core";
import React, { CSSProperties } from "react";
import { Logo } from "./Logo/Logo";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export const App: React.FC = () => {
  const [slideWidth, setSlideWidth] = React.useState(0);

  React.useEffect(() => {
    const resizeSlides = () => {
      setSlideWidth(Math.min(window.innerWidth - 110, 800));
    };
    resizeSlides();
    window.onresize = resizeSlides;
  }, []);

  const slideStyles: CSSProperties = {
    border: "8px solid #00778b",
    // margin: 10,
    maxWidth: 800,
    maxHeight: 500,
    width: slideWidth,
  };

  return (
    <Container>
      <Box
        style={{
          color: "rgba(255, 255, 255, 0.2)",
          textAlign: "center",
        }}
      >
        <Logo />
        <Typography variant="h1">Available for Infinity Game Table</Typography>
        <div style={{ maxWidth: "900px", position: 'relative', left: '50%', transform: 'translate(-50%, 0)' }}>
          <Box
            style={{
              maxWidth: "100%",
              padding: 30,
            }}
          >
            <a href="https://library.infinitygametable.com/game/towerstrike-tower-defense/" target="_blank" rel="noreferrer">
              <img
                src="/images/Towerstrike_Icon.png"
                alt="Logo"
                style={{ maxWidth: 400, width: "100%" }}
              />
            </a>
            <div style={{ marginBottom: 60, width: "100%", maxWidth: "100%" }}>
              <Slider
                centerMode
                dots
                infinite
                speed={500}
                autoplay
                autoplaySpeed={5000}
                slidesToShow={1}
                slidesToScroll={1}
                variableWidth
                adaptiveHeight
                swipeToSlide
              >
                <div>
                  <img
                    src="/images/Screenshot_1.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_2.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_3.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_4.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_5.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_6.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_7.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_8.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
                <div>
                  <img
                    src="/images/Screenshot_9.jpg"
                    alt=""
                    style={slideStyles}
                  />
                </div>
              </Slider>
            </div>
            <div style={{ marginBottom: 20 }}>
              <a
                href="http://paradox-customs.com"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "rgba(255, 255, 255, 0.2)",
                  textDecoration: "none",
                }}
              >
                Paradox Customs Software Development
              </a>
            </div>
          </Box>
        </div>
      </Box>
    </Container>
  );
};
